import React from "react";
import NewDutAccordionAi from "./NewDutAccordionAi";

const AiForm = () => {
  return (
    <div>
      <NewDutAccordionAi showAll={false} saveAll={false} />
      <div className="flex justify-center items-center gap-4 mt-4">
        <button className="w-[61px] h-[40px]  rounded-[24px] border border-[#5AC69F] border-solid  bg-transparent flex justify-center items-center px-[14px] py-[14px] font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.35px] uppercase text-[#1A1A1A]">
          HOLD
        </button>
        <button className="w-[95px] h-[41px] border border-none rounded-[24px] bg-black flex justify-center items-center gap-[8px] pt-[12px] pr-[14px] pb-[12px] pl-[14px]">
          <span className="font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.35px] uppercase text-[#5AC69F]">
            SUBMIT
          </span>
          <span className="text-[#5AC69F] text-[22px] leading-none">→</span>
        </button>
      </div>
    </div>
  );
};

export default AiForm;
